// Catalog prices are Saudi VAT-inclusive. Saved international order prices
// have already had VAT removed; establish their base before any recalculation.
function initializeBundlePrices(items, sourceCountry = 'SA') {
    return items.map(item => ({
        ...item,
        base_price_incl_tax: item.base_price_incl_tax != null
            ? Number(item.base_price_incl_tax)
            : Number(item.price_incl_tax) * (sourceCountry === 'SA' ? 1 : 1.15)
    }));
}

function calculateBundleItems(parent, bundlePrice, countryCode) {
    const children = initializeBundlePrices(parent.bundleOrderedItems);
    const priceForCountry = item => countryCode === 'SA'
        ? item.base_price_incl_tax : item.base_price_incl_tax / 1.15;
    const total = children.reduce((sum, item) =>
        sum + priceForCountry(item) * Number(item.bundleSingleItemQty), 0);
    return children.map(item => {
        const price = priceForCountry(item);
        const quantity = Number(parent.quantity) * Number(item.bundleSingleItemQty);
        const excludingTax = countryCode === 'SA' ? price / 1.15 : price;
        const share = total ? price / total : 0;
        return {
            ...item,
            price: excludingTax,
            price_incl_tax: price,
            quantity,
            applied_rule_ids: parent.applied_rule_ids || null,
            discount: share * Number(parent.discount || 0),
            additional_discount: share * (total - Number(bundlePrice)),
            discount_tax_amt: parent.discount_tax_amt,
            discount_perc: parent.discount_perc,
            row_total: excludingTax * quantity,
            row_total_incl_tax: price * quantity,
            tax_amount: (price - excludingTax) * quantity,
            tax_perc: countryCode === 'SA' ? 15 : 0
        };
    });
}

module.exports = { calculateBundleItems, initializeBundlePrices };
